import type { TaxReturnConnection } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  connection: TaxReturnConnection;
};

export function createUploadTaxReturnCompleted(
  props: Props & { id?: string },
): SmbActionDefinition {
  const { connection, id = `connect-tax-return:done:${connection.id}` } = props;
  return {
    id,
    category: "budget",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="budget"
        badge="Budget"
        title={`${connection.taxYear} tax return uploaded`}
        details={{
          title: "Tax return uploaded",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">Tax year {connection.taxYear}</p>
              <p className="break-all opacity-70">{connection.originalFileName}</p>
            </div>
          ),
        }}
      />
    ),
  };
}
